<template>
  <div class="zip-code-wrap" @click.stop>
    <el-autocomplete
      v-model="displayValue"
      :fetch-suggestions="querySearch"
      :placeholder="placeholder"
      :disabled="disabled"
      :trigger-on-focus="false"
      @select="handleSelect"
      @clear="handleClear"
      @input="handleInput"
      @blur="handleBlur"
      clearable
      popper-class="zip-code-popper"
      :debounce="500"
    >
      <template slot-scope="{ item }">
        <div class="address-suggestion" :title="item.label">
          <span class="address-text">{{ item.label }}</span>
        </div>
      </template>
    </el-autocomplete>
  </div>
</template>

<script>
import { RESPONSE_SUCCESS } from "@/constants"

export default {
  name: 'ZipCodeAddress',
  props: {
    disabled: {
      type: Boolean,
      default: false
    },
    initAddressData: {
      type: Object,
      default: function() {
        return {
          formProps: {
            provinceIdProp: 'provinceId',
            provinceNameProp: 'provinceName',
            cityIdProp: 'cityId',
            cityNameProp: 'cityName',
            areaIdProp: 'areaId',
            areaNameProp: 'areaName',
          },
          defaultData: {},
        }
      },
    },
    /* eslint-disable */
    value: ''
  },
  watch: {
    disabled(newVal) {
      if (newVal) {
        this.displayValue = this.addressText
      }
    },
    'value': {
      handler(val) {
        if (val && typeof val === 'object') {
          const { provinceNameProp, cityNameProp, areaNameProp } = this.initAddressData.formProps
          const parts = []
          if (val[provinceNameProp]) parts.push(val[provinceNameProp])
          if (val[cityNameProp]) parts.push(val[cityNameProp])
          if (val[areaNameProp]) parts.push(val[areaNameProp])
          this.addressText = parts.join('/')
          if (parts.length > 0) {
            this.displayValue = this.addressText
            this.isAddressSelected = true
          }
        } else {
          this.addressText = ''
          this.isAddressSelected = false
        }
      },
      deep: true,
      immediate: true
    },
    'initAddressData.defaultData': {
      handler(val) {
        if (val && Object.keys(val).length > 0) {
          const { provinceIdProp, provinceNameProp, cityIdProp, cityNameProp, areaIdProp, areaNameProp } = this.initAddressData.formProps
          const parts = []
          if (val[provinceNameProp]) parts.push(val[provinceNameProp])
          if (val[cityNameProp]) parts.push(val[cityNameProp])
          if (val[areaNameProp]) parts.push(val[areaNameProp])
          if (parts.length > 0) {
            this.addressText = parts.join('/')
            this.displayValue = this.addressText
            this.isAddressSelected = true
            // Build the address data object
            const data = {}
            data[provinceIdProp] = val[provinceIdProp] || ''
            data[provinceNameProp] = val[provinceNameProp] || ''
            data[cityIdProp] = val[cityIdProp] || ''
            data[cityNameProp] = val[cityNameProp] || ''
            data[areaIdProp] = val[areaIdProp] || ''
            data[areaNameProp] = val[areaNameProp] || ''
            this.selectedData = data
            this.emitInput(data)
          } else {
            // Check if all fields are empty (overseas address case)
            const hasProvinceId = val.hasOwnProperty(provinceIdProp)
            const allEmpty = hasProvinceId && !val[provinceIdProp] && !val[provinceNameProp] && !val[cityIdProp] && !val[cityNameProp]
            if (allEmpty) {
              this.addressText = ''
              this.displayValue = ''
              this.isAddressSelected = false
              const data = {}
              data[provinceIdProp] = ''
              data[provinceNameProp] = ''
              data[cityIdProp] = ''
              data[cityNameProp] = ''
              data[areaIdProp] = ''
              data[areaNameProp] = ''
              this.selectedData = data
              this.emitInput(data)
            }
          }
        }
      },
      deep: true,
      immediate: true
    }
  },
  data() {
    return {
      zipCode: '',
      displayValue: '',
      addressText: '',
      isAddressSelected: false,
      selectedData: null,
      placeholder: '请选择',
    }
  },
  created() {
    this.placeholder = this.$lang('请输入8位邮编匹配地址，境外地址请输入99999999')
  },
  methods: {
    querySearch(queryString, cb) {
      const query = queryString.trim()
      // Only search when 8 digits entered
      if (query.length === 8 && /^\d{8}$/.test(query)) {
        
        // Call API
        this.$API.getAreasByZipCode({ zipCode: query }).then((res) => {
          if (res.code === RESPONSE_SUCCESS && res.data) {
            const data = res.data
            // Format: provinceName/cityName/nativeName
            const label = [data.provinceName, data.cityName, data.nativeName].filter(Boolean).join('/')
            cb([{
              value: label,
              label: label,
              addressData: data
            }])
          } else {
            cb([])
          }
        }).catch(() => {
          cb([])
        })
      } else {
        cb([])
      }
    },
    handleSelect(item) {
      const { provinceIdProp, provinceNameProp, cityIdProp, cityNameProp, areaIdProp, areaNameProp } = this.initAddressData.formProps
      const data = {}

      if (item.isOverseas) {
        // Overseas address - set empty data
        data[provinceIdProp] = ''
        data[provinceNameProp] = ''
        data[cityIdProp] = ''
        data[cityNameProp] = ''
        data[areaIdProp] = ''
        data[areaNameProp] = ''
      } else {
        const addr = item.addressData
        data[provinceIdProp] = addr.provinceId || ''
        data[provinceNameProp] = addr.provinceName || ''
        data[cityIdProp] = addr.cityId || ''
        data[cityNameProp] = addr.cityName || ''
        data[areaIdProp] = addr.areaId || ''
        data[areaNameProp] = addr.nativeName || ''
      }

      this.selectedData = data
      this.addressText = item.label
      this.displayValue = item.label
      this.isAddressSelected = true
      this.emitInput(data)
    },
    handleBlur() {
      // 手动派发 blur 事件到 ElFormItem，触发 el-form-item 验证
      this.dispatchToFormItem('el.form.blur', [this.value])
    },
    handleClear() {
      this.clearAddress()
    },
    handleInput(val) {
      // If user clears the input or starts typing, reset address selection
      if (this.isAddressSelected && val !== this.addressText) {
        this.clearAddress()
      }
    },
    clearAddress() {
      this.selectedData = null
      this.addressText = ''
      this.isAddressSelected = false
      this.emitInput(null)
    },
    emitInput(data) {
      this.$emit('input', data)
      this.$emit('change', data)
      this.$emit('changeValue', data)
      // 手动派发 change 事件到 ElFormItem，触发 el-form-item 验证
      this.dispatchToFormItem('el.form.change', [data])
    },
    dispatchToFormItem(eventName, params) {
      let parent = this.$parent
      while (parent && parent.$options.componentName !== 'ElFormItem') {
        parent = parent.$parent
      }
      if (parent) {
        parent.$emit(eventName, params)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.zip-code-wrap {
  width: 450px;
  display: inline-block;
  ::v-deep .el-autocomplete {
    width: 100%;
  }
  ::v-deep .el-input {
    width: 100%;
  }
}
.zip-code-popper {
  .address-suggestion {
    padding: 5px 10px;
    font-size: 13px;
    line-height: 1.5;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
}
</style>
